import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

/** The parts of the account profile this app reads and writes: the shared language and appearance. */
export interface AccountSettings {
  language?: string;
  theme?: string;
}

@Injectable({ providedIn: 'root' })
export class AccountApiService {
  private readonly base = `${environment.apiUrl}/auth`;

  constructor(private readonly http: HttpClient) {}

  getMe(): Observable<AccountSettings> {
    return this.http.get<AccountSettings>(`${this.base}/me`);
  }

  updateProfile(settings: AccountSettings): Observable<void> {
    return this.http.put<void>(`${this.base}/profile`, settings);
  }
}
